import Ads from '../views/ads/Index.vue';
import AdsSettings from '../views/ads/Settings.vue';
import { checkauth } from '../Helper';

const guard = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

export default [
	{ path: '/ads', name: 'ads', component: Ads, beforeEnter: guard },
	{ path: '/setting/ads', name: 'adsSettings', component: AdsSettings, beforeEnter: guard },
];
